export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20composition%20showcasing%20diverse%20streetwear%20fashion%20pieces%20including%20premium%20sneakers%20oversized%20hoodies%20caps%20and%20accessories%20artfully%20arranged%20on%20a%20warm%20sandstone%20textured%20surface%20accented%20with%20dried%20palm%20leaves%20and%20ceramic%20vessels%20soft%20golden%20hour%20sunlight%20casting%20elongated%20organic%20shadows%20across%20the%20composition%20sophisticated%20lifestyle%20product%20photography%20with%20a%20refined%20earthy%20palette%20of%20warm%20ochre%20muted%20olive%20terracotta%20and%20ivory%20cream%20tones%20negative%20space%20intentional%20composition%20evoking%20a%20luxury%20boutique%20editorial%20spread&width=1920&height=1080&seq=hero-v3-mix-f8k2&orientation=landscape"
          alt="CSSBuy Spreadsheet streetwear and sneaker collection editorial display"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-12">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
            <span className="text-xs font-medium text-background-50 tracking-wider uppercase">Updated Daily</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight max-w-4xl mb-6">
            CSSBuy Spreadsheet &mdash; The Ultimate Free Spreadsheet Collection
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mb-10 leading-relaxed">
            Browse thousands of verified products from trusted sellers through our constantly updated <strong>CSSBuy Spreadsheet</strong>. Discover the best deals, check QC photos, and shop with confidence.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mb-14">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all shadow-lg shadow-primary-500/25 whitespace-nowrap cursor-pointer"
            >
              Explore Spreadsheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 text-base font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Start Shopping
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line"></i>
              </div>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {[
              { icon: 'ri-refresh-line', label: 'Updated Daily' },
              { icon: 'ri-stack-line', label: '10,000+ Products' },
              { icon: 'ri-shield-check-line', label: 'Verified Sellers' },
              { icon: 'ri-global-line', label: 'Free Access' },
              { icon: 'ri-group-line', label: 'Trusted Community' },
              { icon: 'ri-ship-line', label: 'Fast Shipping Support' },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-background-200/80">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${badge.icon} text-sm`}></i>
                </div>
                <span className="text-xs font-medium whitespace-nowrap">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}